import { plural, t } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { Button } from 'designSystem/components/Button'
import { useOptionalSidePanelPresentation } from 'designSystem/components/sidePanelContext'
import type { TimeSeriesTrendRef } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'
import {
  type PreviewTrendHandler,
  trendPreviewFromRef,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/trendPreview'
import { ChartLine } from 'lucide-react'
import React, { useCallback } from 'react'

interface DocChatTrendCardProps {
  trend: TimeSeriesTrendRef
  onPreviewTrend: PreviewTrendHandler
}

export function DocChatTrendCard({
  trend,
  onPreviewTrend,
}: DocChatTrendCardProps): React.ReactElement {
  useLingui()
  const sidePanel = useOptionalSidePanelPresentation()
  const penCount = new Set([
    ...trend.entry_ids,
    ...(trend.context_entry_ids ?? []),
  ]).size
  const penLabel = plural(penCount, { one: '# pen', other: '# pens' })
  const trendLabel = trend.label

  const handleClick = useCallback(() => {
    sidePanel?.keepOpenOnNextOutsideClick()
    onPreviewTrend(trendPreviewFromRef(trend))
  }, [onPreviewTrend, sidePanel, trend])

  return (
    <Button type='button' variant='outline' size='sm' onClick={handleClick}>
      <ChartLine />
      {t`Open trend: ${trendLabel} · ${penLabel}`}
    </Button>
  )
}
